import React from 'react';
import {Container} from 'flux/utils';

import OrderStore from 'stores/OrderStore';
import StockStore from 'stores/StockStore';

import OrdersList from 'views/order/OrdersList';

import HttpService from 'service/HttpService';
import StockOwnerAPI from 'service/api/StockOwnerAPI';

class OrderListContainer extends React.Component {

	static getStores() {
		return [OrderStore, StockStore];
	}

	static calculateState(prevState, props) {
		const session = props.session;
		const product = props.product;

		const orderState = props.orderState;
		return {
			userOrders: session? OrderStore.getUserOrders(): null,
			productOrders: product? OrderStore.getProductOrders(product.id): null,
			allOrders: OrderStore.getOrdersByState(orderState),

			stockOwners: StockStore.getStockOwners(),
		}
	}

	constructor(props) {
		super(props);
		this.getOrderListTitle = this.getOrderListTitle.bind(this);
		this.getOrders = this.getOrders.bind(this);
	}

	componentDidMount() {
		if(this.props.session) {
			if(this.state.userOrders === null)
				HttpService.getMyOrders();

		} else if (this.props.product) {
			if(this.state.productOrders === null)
				HttpService.getProductOrders(this.props.product.id);

		} else if(this.props.orderState) {
			if(this.state.allOrders === null)
				HttpService.getAllOrders(this.props.orderState);
		}


		if(this.props.changeOrderState) {
			//fetch all owners, if not available
			if(!StockStore.getStockOwners())
            	StockOwnerAPI.getAllOwners();
		}
	}

	componentDidUpdate(prevProps) {
		
		//currently, this is only required in case of order state thing from OrderDashboard
		//for others, the above componentDidMount will work
		if(this.props.orderState) {
			if (this.props.orderState !== prevProps.orderState) {
				if(this.state.allOrders === null)
					HttpService.getAllOrders(this.props.orderState);
			}
		}
	}


	getOrderListTitle() {
		if(this.props.session)
			return "My Orders";

		if(this.props.product)
			return this.props.product.title+ " Orders";

		return null;
	}

	getOrders() {
		if(this.props.session)
			return this.state.userOrders;

		if(this.props.product)
			return this.state.productOrders;

		return this.state.allOrders;
	}

	render() {
		const orders = this.getOrders();
		const title = this.getOrderListTitle();

		return <OrdersList style={{margin: "10px 0", padding: "0 5px"}} 
									orders={orders} title={title} 
									showPaymentOption={this.props.showPaymentOption}
									showProductInfo={this.props.showProductInfo} 
									changeOrderState={this.props.changeOrderState} 
									showExportAsCSV={this.props.showExportAsCSV} 
									stockOwners={this.state.stockOwners} />
	}
}


export default Container.create(OrderListContainer, {withProps: true});


// WEBPACK FOOTER //
// ./src/containers/OrderListContainer.js